var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 15,
    viewBox: "0 0 8 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.904,
    d: "M.925 1.393l5.544 6.284L.925 13.96"
  })));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='15' viewBox='0 0 8 15'%3e %3cpath fill='none' stroke='currentColor' stroke-width='1.904' d='M.925 1.393l5.544 6.284L.925 13.96'/%3e %3c/svg%3e";
export { SvgArrowRight as ReactComponent };